// @flow

import {
  REQUEST_STORING_CONFIGURATION,
  FAILURE_STORING_CONFIGURATION,
  SUCCESS_STORING_CONFIGURATION,
  RETRY_STORING_CONFIGURATION,
  RESET_STORING_CONFIGURATION,
  FORM_CHANGE_STORING_CONFIGURATION,
} from './constants';

import type {
  Actions,
  ConfigFormState,
} from './types';

const initialState: ConfigFormState = {
  loading: false,
  error: false,
  errorResponse: {},
  saved: false,
  loginHash: '',
};

const configForm = (
  state: ConfigFormState = initialState,
  action: Actions,
) => {
  switch (action.type) {
    case RESET_STORING_CONFIGURATION:
    case FORM_CHANGE_STORING_CONFIGURATION:
      return initialState;

    case RETRY_STORING_CONFIGURATION:
      return {
        ...state,
        error: false,
        saved: false,
        errorResponse: {},
      };

    case REQUEST_STORING_CONFIGURATION:
      return {
        ...state,
        saved: false,
        loading: true,
      };

    case FAILURE_STORING_CONFIGURATION:
      return {
        ...state,
        loading: false,
        error: true,
        saved: false,
        errorResponse: action.error,
      };

    case SUCCESS_STORING_CONFIGURATION:
      return {
        ...state,
        loginHash: action.response.data && action.response.data.loginhash ? action.response.data.loginhash : '',
        saved: true,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
};

export default configForm;
